import { type Params, stringifyParams } from '../../utils/build-api-url';
import { findAllGetParameters, findGetParameter } from '../../utils/parameters';
import type { IContextState } from '../state';

export const syncWithUrl = (draft: IContextState) => {
  const { term } = draft;
  const filter =
    (draft.itemFilter && draft.itemFilter.language?.length > 0) ||
    (draft.itemFilter && draft.itemFilter?.fileType?.length > 0) ||
    (draft.itemFilter && draft.itemFilter?.variants?.length > 0)
      ? JSON.stringify(draft.itemFilter)
      : null;
  const categoriesQuery = Object.keys(draft.selected || {});
  const categoryParams = categoriesQuery.reduce(
    (acc, depth) => ({
      ...acc,
      [`c-${depth}`]: draft.selected[parseInt(depth, 10)].toString(),
    }),
    {},
  );

  const downloadGroup = findAllGetParameters('download_group');
  const downloadItem = findGetParameter('download_item');

  let params: Params = {};

  if (downloadGroup.length > 0 && draft.shareIds) {
    params['download_group'] = downloadGroup;
  }

  if (!!downloadItem && draft.shareIds) {
    params['download_item'] = downloadItem;
  }

  if (!!term || !!filter || Object.keys(categoriesQuery).length > 0) {
    params = {
      search: term ? term.trim().replace(/\s+/g, ' ') : undefined,
      filter: filter ? filter : undefined,
      ...(categoriesQuery ? categoryParams : {}),
    };
  }

  window.history.replaceState(
    {},
    document.title,
    `?${stringifyParams(params)}${window.location.hash || ''}`,
  );
};
